module.exports = __webpack_public_path__ + "static/media/home-beacon.609309ad.png";